<template>
  <li
    class="nav-list flex-grow-1 mainlist text-center"
    :class="{ active: isSubTabActive }"
    @click="$emit('tabClick', item)"
  >
    <div style="height: 100%" class="li-text">
      <p class="mb-0" style="font-size: 13px">
        <v-icon :size="16" class="mr-1">
          {{ item.icon || alternateIcon }}
        </v-icon>
        {{ textFormat(item.title) }}
      </p>
      <div>
        <v-icon
          size="15"
          class="ml-1"
          @click.stop="$emit('closeTab', { item, isActive: isSubTabActive })"
        >
          {{ icons.mdiClose }}
        </v-icon>
      </div>
    </div>
  </li>
</template>

<script>
import store from '@/store'
import { storeActions } from '@/store/storeConstants'
import { mdiChevronDown, mdiClose } from '@mdi/js'
import useSubTabService from '@core/layouts/composable/horizontal-tab/useSubTabService'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    pinned: {
      type: Boolean,
      default: true,
    },
    activeModule: {
      type: String,
      default: 'crm',
    },
  },
  setup(props, { emit }) {
    const { CANCEL_TAB_REQUEST } = storeActions
    const { isSubTabActive } = useSubTabService(props.item)

    const textFormat = text => {
      if (text?.length > 14) {
        return `${text.substring(0, 18)}..`
      }

      return text
    }

    const closeTab = () => {
      store.commit('tabPersist/RESET_TOGGLE_DROPDOWN')
      store.dispatch(`tabs/${CANCEL_TAB_REQUEST}`, props.item)
      emit('onResize')
    }

    return {
      isSubTabActive,
      textFormat,
      closeTab,
      icons: {
        mdiClose,
        mdiChevronDown,
      },
    }
  },
}
</script>
<style scoped>
.nav-list {
  list-style: none;
  min-width: 180px;
  width: 180px;
  max-width: 220px;
  height: 42px;
  border-right: thin solid #e3e1e1;
  color: black;
}
.nav-list.mainlist.active {
  border-top: 3.5px solid #007eb9;
  border-bottom: 0px;
}
.nav-list .li-text {
  display: flex;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
}
.nav-list.mainlist.active .li-text {
  background: #fff;
  color: black;
  margin-top: 2px;
}
.nav-list.active {
  background: #fff;
  color: black;
}
</style>
